// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TvBi","title":"styles_title__bVdR7"};